import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { FormattedMessage } from '@flipster/i18n';
import { css } from '@flipster/styled-system/css';
import { grid, stack } from '@flipster/styled-system/patterns';
import { SocialReferralEvent } from '@flipster/utils/segment/events/social-referral';

import { SegmentPage } from '../misc/segment/segment-page';
import { socialReferralBunja } from './bunja';

export const CompletedPage = () => {
  const { campaignAtom } = useBunja(socialReferralBunja);
  const campaign = useAtomValue(campaignAtom);

  if (!campaign) return null;
  return (
    <>
      <SegmentPage
        name={SocialReferralEvent.SocialReferralEndPageView}
        context={{ campaign_id: campaign.campaignId }}
      />
      <main
        className={stack({
          p: 16,
          margin: '0 auto',
          maxW: 'desktopMaxWidth',
          minH: 'minHeightWithoutNavigation',
          tabletDown: {
            justifyContent: 'space-between',
            gap: 32,
            pb: 32,
          },
          tablet: { gap: 80 },
        })}
      >
        <div
          className={grid({
            tabletDown: {
              gridTemplateAreas: `
          "title"
          "image"
        `,
            },
            tablet: {
              pt: 80,
              gridTemplateColumns: '1fr 1fr',
              gridAutoRows: 'auto',
              gridTemplateAreas: '"title image"',
            },
          })}
        >
          <div
            className={stack({
              gridArea: 'title',
              tabletDown: { textAlign: 'center', gap: 16 },
              tablet: { justifyContent: 'center', gap: 24 },
            })}
          >
            <div className={stack({ gap: 8 })}>
              <p className={css({ textStyle: 'Title/S', color: 'content.accent.info' })}>{campaign.campaignTitle}</p>
              <p className={css({ textStyle: 'Display/XL', color: 'content.default.level-5', whiteSpace: 'pre-wrap' })}>
                <FormattedMessage id='Autogen_common.r251126.s_This_promotion_has_ended' />
              </p>
            </div>
            <p className={css({ textStyle: 'Text/L/Regular', color: 'content.default.level-3' })}>
              <FormattedMessage id='Autogen_common.r251126.s_If_you_ve_successfully_completed_the_goal_rewards_will_be_sent_within_7_days_Fraud_or_abuse_will_result_in_disqualification_and_loss_of_rewards' />
            </p>
          </div>
          <img
            alt='background of social referral page'
            src={campaign.webLandingPageContent.mainImageUrl}
            className={css({
              gridArea: 'image',
              m: '0 auto',
              h: 280,
              objectFit: 'contain',
              py: 14,
              tabletDown: { w: '100%' },
            })}
          />
        </div>
      </main>
    </>
  );
};
